import React, { PropTypes } from 'react';
import DatePicker from 'react-datepicker';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';

const moment = require('moment');

const PeriodFromTo = (props) => {
  return (
    <FormGroup controlId="startEndDate">
      <Col sm={6}>
        <FormGroup controlId="">
          <Col componentClass={ControlLabel} sm={5}>
            {props.startDateLabel}
          </Col>
          <Col sm={7}>
             <DatePicker
                id="startDate"
                placeholderText="DD/MM/YYYY"
                dateFormat="DD/MM/YYYY"
                todayButton={'Today'}
                autoComplete="off"
                minDate={moment()}
                selected={props.startDate != null ? moment(props.startDate) : null}
                onChange={props.handleChangeStartDate}
                required
                />
          </Col>
        </FormGroup>
      </Col>
      <Col sm={6}>
        <FormGroup controlId="">
          <Col componentClass={ControlLabel} sm={2}>
            {props.endDateLabel}
          </Col>
          <Col sm={4}>
             <DatePicker
                placeholderText="DD/MM/YYYY"
                dateFormat="DD/MM/YYYY"
                todayButton={'Today'}
                autoComplete="off"
                minDate={moment()}
                selected={props.endDate != null ? moment(props.endDate) : null}
                onChange={props.handleChangeEndDate}
                required
                disabled
                />
          </Col>
        </FormGroup>
      </Col>
    </FormGroup>
  )
}

PeriodFromTo.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  startDateLabel: PropTypes.string,
  endDateLabel: PropTypes.string,
  handleChangeStartDate: PropTypes.func,
  handleChangeEndDate: PropTypes.func,

};

export default PeriodFromTo;



// WEBPACK FOOTER //
// ./src/app/components/coverNoteCVComponent/periodFromTo/PeriodFromTo.js